import { type LayoutMode } from './types';
import { desktopPages } from './desktop';
import { embeddedPages } from './embedded';
import { mobilePages } from './mobile';

export * from './types';

/**
 * pages — Every page component, keyed by layout mode.
 *
 * Lets callers resolve a whole page set once (`pages[mode]`) and render
 * `Page.AppPicker`, `Page.IssuanceReview`, … instead of branching on
 * `isEmbedded` / `isMobile` at every state.
 *
 * `mobile` keeps its wider type so `pages.mobile.FlowStart` stays reachable —
 * the `mobileFlowStart` state is mobile-only by construction.
 */
export const pages = {
  embedded: embeddedPages,
  mobile: mobilePages,
  desktop: desktopPages,
};

/**
 * Resolves the active layout mode. Priority: embedded > mobile > desktop.
 */
export function resolveLayoutMode({
  isMobile,
  isEmbedded,
}: {
  isMobile: boolean;
  isEmbedded: boolean;
}): LayoutMode {
  if (isEmbedded) return 'embedded';
  return isMobile ? 'mobile' : 'desktop';
}
